module.exports = __webpack_public_path__ + "img/linkedin.9e36c8fd.svg";